import MaterialTable, {
  Icons,
  MaterialTableProps,
  MTableBodyRow,
  MTableCell,
} from 'material-table';
import React, { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Edit from '@material-ui/icons/Edit';
import SaveAlt from '@material-ui/icons/SaveAlt';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Search from '@material-ui/icons/Search';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Remove from '@material-ui/icons/Remove';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Refresh from '@material-ui/icons/Refresh';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

const tableIcons: Icons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }),
)(MTableCell);

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }),
)(MTableBodyRow);
const MaterialTableComponent = (props: MaterialTableProps<any>) => {
  const { icons, actions, ...others } = props;
  const tableRef = React.createRef<any>();

  return (
    <MaterialTable
      {...others}
      tableRef={tableRef}
      actions={[
        {
          icon: () => <Refresh />,
          tooltip: 'Rafraîchir',
          isFreeAction: true,
          onClick: () =>
            tableRef?.current && tableRef?.current?.onQueryChange(),
        },
        ...(actions ?? []),
      ]}
      icons={{ ...tableIcons, ...icons }}
      components={{
        Cell: (props) => <StyledTableCell {...props} />,
        Row: (props) => <StyledTableRow {...props} />,
      }}
      style={{ zIndex: 0 }}
      options={{
        toolbarButtonAlignment: 'left',
        debounceInterval: 500,
        pageSize: 10,
        searchFieldVariant: 'outlined',
        headerStyle: {
          maxHeight: 64,
          paddingTop: 8,
          paddingBottom: 8,
          ...props.options?.headerStyle,
        },
        filterCellStyle: {
          paddingTop: 8,
          paddingBottom: 8,
          ...props.options?.filterCellStyle,
        },
        maxBodyHeight: 'calc(100vh - 240px)',
        ...props.options,
      }}
    />
  );
};

export default MaterialTableComponent;
